import { HeaderType } from 'utils/types';

export const ACCOUNTS_HEADERS: Array<HeaderType> = [
  { label: 'Account', sortBy: 'name' },
  { label: '$', sortBy: 'sales', default: true },
  { label: '$ Chg YAGO', sortBy: 'salesDelta' },
  { label: 'Units', sortBy: 'units' },
  { label: 'Units Chg YAGO', sortBy: 'unitsDelta' },
  { label: 'POD', sortBy: 'pod' },
  { label: 'Items', sortBy: 'items' },
  { label: 'Stores Selling', sortBy: 'storesSelling' },
  { label: 'Potential Stores', sortBy: 'potentialStores' },
  { label: 'Voids', sortBy: 'voids' },
  { label: '$ Opp Gap', sortBy: 'opportunityGap' }
];

export const ACCOUNTS_TYPES_MAP = new Map([
  ['name', 'string'],
  ['sales', 'currency'],
  ['salesDelta', 'percentage'],
  ['units', 'number'],
  ['unitsDelta', 'percentage'],
  ['pod', 'number'],
  ['items', 'number'],
  ['storesSelling', 'number'],
  ['potentialStores', 'number'],
  ['voids', 'number'],
  ['opportunityGap', 'currency']
]);

export const STORES_HEADERS: Array<HeaderType> = [
  { label: 'Store', sortBy: 'name' },
  { label: '$', sortBy: 'sales', default: true },
  { label: '$ Chg YAGO', sortBy: 'salesDelta' },
  { label: 'Units', sortBy: 'units' },
  { label: 'Units Chg YAGO', sortBy: 'unitsDelta' },
  { label: 'Items', sortBy: 'items' },
  { label: 'Voids', sortBy: 'voids' },
  { label: 'Top Opportunity', sortBy: 'topOpportunity' }
];

export const STORES_TYPES_MAP = new Map([
  ['name', 'string'],
  ['sales', 'currency'],
  ['salesDelta', 'percentage'],
  ['units', 'number'],
  ['unitsDelta', 'percentage'],
  ['items', 'number'],
  ['voids', 'number'],
  ['topOpportunity', 'string']
]);

export const ITEMS_HEADERS: Array<HeaderType> = [
  { label: 'Item Description', sortBy: 'name' },
  { label: 'UPC', sortBy: 'upc' },
  { label: '$', sortBy: 'sales', default: true },
  { label: '$ Chg YAGO', sortBy: 'salesDelta' },
  { label: 'Units', sortBy: 'units' },
  { label: 'Units Chg YAGO', sortBy: 'unitsDelta' },
  { label: 'ARP', sortBy: 'arp' },
  { label: 'POD', sortBy: 'pod' },
  { label: 'POD Chg', sortBy: 'podDelta' },
  { label: 'Units / SS / Wk', sortBy: 'unitsSsw' }
];

export const ITEMS_TYPES_MAP = new Map([
  ['name', 'string'],
  ['upc', 'string'],
  ['sales', 'currency'],
  ['salesDelta', 'percentage'],
  ['units', 'number'],
  ['unitsDelta', 'percentage'],
  ['arp', 'currency-cents'],
  ['pod', 'number'],
  ['podDelta', 'percentage'],
  ['unitsSsw', 'number-2']
]);

export const BRANDS_HEADERS: Array<HeaderType> = [
  { label: 'Brand', sortBy: 'name' },
  { label: 'Dollars', sortBy: 'sales', default: true },
  { label: '$ Chg YAGO', sortBy: 'salesDelta' },
  { label: 'Units', sortBy: 'units' },
  { label: 'Units Chg YAGO', sortBy: 'unitsDelta' },
  { label: 'POD', sortBy: 'pod' },
  { label: 'Stores Selling', sortBy: 'storesSelling' },
  { label: 'POD Gains', sortBy: 'podGains' },
  { label: 'POD Losses', sortBy: 'podLosses' },
  { label: 'Voids', sortBy: 'voids' },
  { label: 'Opp Gap', sortBy: 'opportunityGap' }
];

export const BRANDS_TYPES_MAP = new Map([
  ['name', 'string'],
  ['sales', 'currency'],
  ['salesDelta', 'percentage'],
  ['units', 'number'],
  ['unitsDelta', 'percentage'],
  ['pod', 'number'],
  ['storesSelling', 'number'],
  ['podGains', 'number'],
  ['podLosses', 'number'],
  ['voids', 'number'],
  ['opportunityGap', 'currency']
]);
